<template>
    <div class="doc-page">
        <nuxt-link to="/pomosh-klientam/" v-if="$device.isMobile" class="sm-title page__title">
            <div>{{ title }}</div>
            <span class="return-btn">
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.25 1.25L0.75 5.75L5.25 10.25" stroke="black" />
                </svg>
            </span>
        </nuxt-link>
        <div class="doc-page__title">{{ title }}</div>
        <div class="doc-page__content" v-html="text"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    layout: "help",
    name: "Dokument",
    head() {
        return {
            title: this.title + " | " + this.$i18n.t("pps_title"),
        };
    },
    data() {
        return {
            text: "",
            title: "",
        };
    },
    watch: {
        langust() {
            this.$axios.get("/api/documents/" + this.$route.params.slug).then((res) => {
                this.text = res.data.body;
                this.title = res.data.title;
                this.$store.commit("crumbs/change", this.crumbs);
            });
        },
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
        crumbs() {
            return [
                {
                    name: this.$i18n.t("customer_help"),
                },
                { name: this.title },
            ];
        },
    },
    mounted() {
        this.$axios.get("/api/documents/" + this.$route.params.slug).then((res) => {
            this.text = res.data.body;
            this.title = res.data.title;
            this.$store.commit("crumbs/change", this.crumbs);
        });
    },
};
</script>

<style lang="less">
.doc-page {
    &__title {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 140%;
        margin-bottom: 32px;
        @media screen and (max-width: 830px) {
            padding-top: 35px;
        }
    }
    &__subtitle {
        p + & {
            margin-top: 20px;
            font-weight: 700;
            text-transform: uppercase;
        }
    }
    &__content {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 110%;
        color: #7b7b7b;
        p {
            margin-bottom: 10px;
        }
        a {
            text-decoration: underline;
        }
        strong {
            font-weight: 700;
            margin-bottom: 16px;
            margin-top: 24px;
            display: block;
            text-transform: uppercase;
        }
        ul {
            margin-bottom: 10px;
            li {
                display: flex;
                margin-top: 5px;
                &:before {
                    content: "";
                    width: 8px;
                    height: 8px;
                    margin-right: 8px;
                    margin-top: 4px;
                    background: url(~assets/icons/crystal.svg?inline) center / contain no-repeat;
                    opacity: 0.5;
                }
            }
        }
    }
    // @media screen and (max-width: 830px) {
    //     margin-top: -36px;
    // }
}
</style>
